module.exports = __webpack_public_path__ + "img/20191014165139605.0b50057e.jpg";